import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { RatePackageEventType } from '../rate-package.event.type';
import { TweenMax, Quint } from 'gsap';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { Pacote } from '../models/pacote.model';
import { EventTypes } from '../../../shared/EventTypes';
import { SharedService } from '../../../shared/shared.service';

@Component({
	selector: 'app-package-result',
	templateUrl: './package-result.component.html',
	styleUrls: ['./package-result.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class PackageResultComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() hirePackage: Pacote;
	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="package-result"]';
	private confirmList: Array<ListItem> = [];
	public active = false;
	public message = 'Contratação realizada com sucesso!';
	public codSituacao: number;
	public messageType = 'success';

	constructor(private sharedService: SharedService) { }

	ngOnInit() {
		AppEventDispatcher.listen(RatePackageEventType.STEPS.RESULT, data => {
			if (data.show) {
				this.codSituacao = data.data;
				this.messageType = this.codSituacao === 1 ? 'warning' : 'success';
				this.message = this.codSituacao === 1 ? 'Contratação de pacote de serviço aguardando aprovação' : 'Contratação realizada com sucesso!';
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RatePackageEventType.STEPS.RESULT);
	}

	buildConfirmList() {
		const FP = new FormatPricePipe();
		this.confirmList = [];
		this.confirmList.push(new ListItem('Pacote:', this.hirePackage.nmPacote));
		this.confirmList.push(new ListItem('Valor do pacote:', FP.transform(this.hirePackage.vlrPacote, false) + '/ mês'));
	}


	show() {
		this.setTitleSubtitle.emit({
			step: 'result'
		});

		this.active = true;
		this.buildConfirmList();
		this.preload(false);
	}

	hide() {
		this.active = false;
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, { element: '[data-component="rate-package"] .content', show: active, delay: delay });
	}

	goBack() {
		this.sharedService.changeRerender(true);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/package-result/package-result.component.ts